/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import DevicesTable from './DevicesTable';
import { centerClient } from '../../shared/clients';
import type { Account as AccountModel, Account as AccountDto, Device } from '../../shared/generated';
import context from './context/shared';
import { observer } from 'mobx-react-lite';
import { Button, Form, Modal } from 'react-bootstrap';
import { Floppy2Fill, PersonXFill } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { useBackButton } from '../../utils/backButton';
import { useIsMobile } from '../shared';

export interface IDevices_{
    Devices_: Device[];
}
const Account = observer(() => {
    const [account, setAccount] = useState<AccountModel | null>(null);
    const { currentNode } = context;
    const [isLoading, setIsLoading] = useState(false);
    const successAccoundLoad = (res: AccountDto) => {
        setAccount(res as unknown as AccountModel);
    };
    function loadAccount() {
        const sendBody: AccountDto = {
            Login: currentNode?.name,
            OriginalLogin: currentNode?.name,
            ClientId: currentNode?.parentId
        } as AccountDto;
        setIsLoading(true);
        centerClient.getAccount(sendBody)
            .then((res) => {
                const data = res.data;
                if (data)
                    successAccoundLoad(data);
            })
            .catch(() => void 0)
            .finally(() => setIsLoading(false));
    }
    useEffect(() => {
        if (typeof window !== 'undefined') {
            context.setShowAccountSettings(false);
            loadAccount();
        }
    }, [currentNode]);
    return <>
        {account && <DevicesTable data={account.Devices?.Devices_ || []} account={account} setAccount={setAccount} isLoading={isLoading} />}
        {account && <AccountSettingsModal account={account} setAccount={setAccount} />}
    </>
})

interface IAccountSettingsModalProps {
    account: AccountModel;
    setAccount: Dispatch<SetStateAction<AccountModel | null>>;
}

const AccountSettingsModal = observer((props: IAccountSettingsModalProps) => {
    const { account, setAccount } = props;
    const { showAccountSettings, setShowAccountSettings, refreshTree, handleDeleteAccount } = context;
    const [isSending, setIsSending] = useState(false);
    const handleAccount = (evt) => {
        const name = evt.target.name;
        const val = evt.target.value;
        const newAccount = { ...account } as AccountModel;
        newAccount[name] = val;
        setAccount(newAccount);
    }
    const save = () => {
        if (isSending)
            return;
        setIsSending(true);
        centerClient.updateAccount(account as AccountDto)
            .then(() => {
                toast.success("Настройки логина успешно сохранены");
                refreshTree();
            })
            .catch(() => void 0)
            .finally(() => setIsSending(false));
    }
    const handleClose = () => setShowAccountSettings(false);
    const isMobile = useIsMobile();
    useBackButton(handleClose, showAccountSettings && isMobile);
    return (
        <Modal show={showAccountSettings} onHide={handleClose} className="mobileBottomSheet" >
            <Modal.Header closeButton>
                <Modal.Title>Настройки логина</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label>Логин</Form.Label>
                        <Form.Control type="input" name="Login" onChange={handleAccount} value={account.Login} disabled={isSending} placeholder="Логин..." />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Пароль</Form.Label>
                        <Form.Control type="input" name="Password" onChange={handleAccount} value={account.Password} disabled={isSending} placeholder="Пароль..." />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', marginTop: '.5rem', width: '100%' }}>
                    <Button variant="custom" onClick={() => { handleClose(); handleDeleteAccount(); }}>
                        <PersonXFill className="marginRight" />
                        Удалить логин
                    </Button>
                    <div style={{ display: 'flex', gap: '.5rem' }}>
                        <Button variant="custom" onClick={save} disabled={isSending}>
                            <Floppy2Fill className="marginRight" />
                            Сохранить
                        </Button>
                        <Button variant="custom" onClick={handleClose}>
                            Закрыть
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
});

export default Account;
